import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HorizontalBar } from 'react-chartjs-2';
import { withStyles } from '@material-ui/styles';
import H6 from 'components/base/titles/CardHeading/H6';
import LabelWithInfoIcon from 'components/base/LabelWithInfoIcon/LabelWithInfoIcon';
import withAll from 'components/base/withAll';
import { formatNumber } from 'utils/helpers';
import { config } from 'theme';

const styles = () => ({
  root: {},
});

const PreviousPeriodCompared = ({ classes, data }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    tooltips: {
      enabled: true,
      displayColors: false,
      intersect: false,
      mode: 'index',
      callbacks: {
        label: (tooltip, dataset) => {
          const { datasetIndex } = tooltip;
          // Only show for the main dataset. The other dataset is just for visual effect.
          if (datasetIndex !== 0) {
            return '';
          }
          return dataset.datasets.map(d => (
            `${d.label}: ${formatNumber(d.data[tooltip.index], '$0.00a', '-')}`
          ));
        },
      },
    },
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        boxWidth: 12,
        usePointStyle: true,
      },
    },
    scales: {
      yAxes: [{
        gridLines: {
          display: true,
          drawOnChartArea: false,
        },
      }],
      xAxes: [{
        display: true,
        gridLines: {
          display: true,
          drawOnChartArea: true,
        },
        ticks: {
          callback: value => formatNumber(value, '$0a', '$0'),
        },
      }],
    },
    plugins: {
      datalabels: {
        display: false,
      },
    },
  };

  const labels = data.map(b => b.name);
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Current Period',
        data: data.map(b => b.currentPeriod.total),
        backgroundColor: config.palette.green.main,
        barThickness: 30,
      },
      {
        label: 'Previous Period',
        data: data.map(b => b.previousPeriod.total),
        backgroundColor: config.palette.blue.dark,
        barThickness: 30,
      },
    ],
  };

  const chartHeight = Math.max(200, 100 * data.length);

  return (
    <div className={classes.root}>
      <H6>
        <LabelWithInfoIcon
          labelText="Estimated Creator Spend - Comparison by Previous Period"
          tooltip="Calculated overall totals by selected period against the previous period."
        />
      </H6>
      <HorizontalBar
        data={chartData}
        options={options}
        height={chartHeight}
        redraw
      />
    </div>
  );
};

PreviousPeriodCompared.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    currentPeriod: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }),
    previousPeriod: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }),
  })),
};

PreviousPeriodCompared.defaultProps = {
  data: [],
};

const mapStateToProps = ({ competitiveReportEstimatedSpend: { data: { data } } }) => ({
  data,
});

export default withAll(
  connect(mapStateToProps, null),
  withStyles(styles),
)(PreviousPeriodCompared);
